import I18n from '@module/i18n';

export default {
  helpItem: {
    name: I18n.t('navigation.help.name'),
    path: '/help',
    items: [],
  },
  homeItem: { path: '/', name: I18n.t('navigation.home.name') },
  aboutItem: {
    path: '/about',
    name: I18n.t('navigation.about_us.items.about'),
  },
  productsItem: {
    path: '/products',
    name: I18n.t('navigation.about_us.items.products'),
  },
  advertiseItem: {
    path: '/advertise',
    name: I18n.t('navigation.about_us.items.advertise'),
  },
  transfersItem: {
    path: '/transfers',
    name: I18n.t('navigation.user.items.sent'),
  },
  spacesItem: {
    path: '/projects',
    name: I18n.t('navigation.user.items.projects'),
  },
  contactsItem: {
    path: '/contacts',
    name: I18n.t('navigation.user.items.contacts'),
  },
  profileItem: {
    path: '/profile',
    name: I18n.t('navigation.user.items.profile'),
  },
  accountItem: {
    path: '/account',
    name: I18n.t('navigation.user.items.account'),
  },
  signoutItem: {
    path: '/signout',
    name: I18n.t('navigation.sign_out'),
  },
  uploadItem: {
    path: '/upload',
    name: I18n.t('transfer.buttons.new_transfer'),
  },
  upgradeItem: {
    name: I18n.t('navigation.about_us.items.upgrade'),
    path: '/upgrade',
    queryParams: {
      trk: 'WT202004_upgrade_fa_to_pro',
    },
  },
  plusItem: {
    path: '/pro',
    queryParams: {
      trk: 'WT201610_AboutPlus',
    },
    name: I18n.t('navigation.about_us.items.plus'),
  },
  loginItem: {
    name: I18n.t('navigation.login'),
    path: '/log-in',
    items: [],
    trackEvent: {
      category: 'plus',
      action: 'click_signin',
    },
  },
};
